import * as yup from 'yup';

export const email = yup
  .string()
  .email('Email must be a valid email')
  .required('Email is required');
export const password = yup.string().required('Password is required');
export const amount = yup.string().required('Required');
export const reason = yup.string().required('Required');

export const planName = yup.string().required('Required');
export const planType = yup.string().required('Required');
export const planDuration = yup.string().required('Required');
export const planCost = yup.string().required('Required');
export const maxDuration = yup.string().required('Required');
export const timeDuration = yup.string().required('Required');
export const participant = yup.string().required('Required');
export const description = yup.string().required('Required');

export const name = yup.string().required('Required');
export const string_required = yup
  .string()
  .required('Required')
  .typeError('Required');
export const phone = yup.string().required('Required');
export const billNumber = yup.string().required('Required');
export const date = yup.string().required('Required');
export const features = yup.string().required('Required');
export const number = yup.number().required('Required');
